import React, { FC } from 'react';
import styles from './public_page_layout.module.scss';

export const PublicPageLayout: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
